import React from 'react'

import Config from '~/config'
const appVersion = require('~/../package.json').version

// version from response - first param, local version second param
const semverGreaterThan = (versionA: string, versionB: string) => {
  const versionsA = versionA.split(/\./g)

  const versionsB = versionB.split(/\./g)
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift())
    const b = Number(versionsB.shift())
    // eslint-disable-next-line no-continue
    if (a === b) continue
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b)
  }
  return false
}

type CacheBusterProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any
}

export type CacheBusterState = {
  loading: boolean
  isLatestVersion: boolean
  refreshCacheAndReload: Function
}

class CacheBuster extends React.Component<CacheBusterProps, CacheBusterState> {
  constructor(props: CacheBusterProps) {
    super(props)
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: () => {
        console.log('Clearing cache and hard reloading...')
        if (caches) {
          // Service worker cache should be cleared with caches.delete()
          caches.keys().then(function (names) {
            for (const name of names) caches.delete(name)
          })
        }

        // delete browser cache and hard reload
        window.location.reload()
      }
    }
  }

  componentDidMount() {
    const metaJsonPath = Config.relativePath ? './meta.json' : '/meta.json'
    fetch(metaJsonPath)
      .then((response) => response.json())
      .then((meta) => {
        const latestVersion = meta.version
        const currentVersion = appVersion

        const shouldForceRefresh = semverGreaterThan(
          latestVersion,
          currentVersion
        )
        if (shouldForceRefresh) {
          console.log(
            `We have a new version - ${latestVersion}. Should force refresh`
          )
          this.setState({ loading: false, isLatestVersion: false })
        } else {
          console.log(
            `You already have the latest version - ${latestVersion}. No cache refresh needed.`
          )
          this.setState({ loading: false, isLatestVersion: true })
        }
      })
  }
  render() {
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state
    const { children } = this.props
    return (
      <>
        {children({
          loading,
          isLatestVersion,
          refreshCacheAndReload
        })}
      </>
    )
  }
}

export default CacheBuster
